const recursos = [
  {
    nombre: "Manual de ingreso de solicitudes",
    tipo: "Video tutorial · YouTube",
    url: "https://youtu.be/dDWYuzcQ9Qg",
    icon: "▶",
    iconBg: "bg-codelco/10",
    btnLabel: "Ver video",
  },
  {
    nombre: "Procedimiento de aprobación",
    tipo: "Video explicativo · YouTube",
    url: "https://youtu.be/Shb7dQikyDc",
    icon: "▶",
    iconBg: "bg-codelco/10",
    btnLabel: "Ver video",
  },
  {
    nombre: "Ingreso de solicitud (Archivo)",
    tipo: "Archivo PDF · Solicitud-2016",
    url: "https://www.dentistacontralor.cl/static/Solicitud-2016.pdf",
    icon: "📄",
    iconBg: "bg-blue-50",
    btnLabel: "Descargar PDF",
  },
];

export default function Descargas() {
  return (
    <section className="px-6 md:px-8 py-8 max-w-5xl mx-auto">
      <div className="section-tag">Recursos</div>
      <h2 className="section-title">Descargas y Links</h2>

      <div className="flex flex-col gap-3">
        {recursos.map((r, i) => (
          <div
            key={i}
            className="card p-4 flex items-center gap-4 hover:shadow-md transition-shadow"
          >
            <div
              className={`w-10 h-10 rounded-xl flex items-center justify-center text-xl flex-shrink-0 ${r.iconBg}`}
            >
              {r.icon}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-navy-600">{r.nombre}</div>
              <div className="text-xs text-gray-400 mt-0.5">{r.tipo}</div>
            </div>
            <a
              href={r.url}
              target="_blank"
              rel="noreferrer"
              className="flex-shrink-0 bg-gray-100 hover:bg-codelco hover:text-white border border-gray-200 hover:border-codelco text-navy-600 text-xs font-medium px-4 py-2 rounded-lg transition-colors"
            >
              {r.btnLabel} →
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
